import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image";
import Button from "./button";
import { Link } from "gatsby";
import { HiMenu } from "react-icons/hi";
// Note: see below
// import { IoIosSearch } from "react-icons/io";
import { device } from "../styles/global";
import ContactHeader from "./contact-header";
import DropdownNav from "./dropdown-nav";
import { headerLinks } from "../library/nav-links";
import SideNav from "./side-nav";

const StyledHeader = styled.header`
  padding: 1.15rem 0;
  position: sticky;
  top: -1px;
  z-index: 100;
  background: var(--white);
  box-shadow: var(--gray-shadow);

  &.scrolled-header {
    padding: 0.875rem 0;

    .logo {
      width: 4.28rem;
    }
  }

  .width-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .logo {
    width: 6.28rem;
    transition: width 0.3s;
  }

  nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 3rem;
  }

  ul.nav-links {
    display: flex;
    text-transform: uppercase;
    gap: 1rem;
    justify-content: space-between;
    max-width: 40rem;
    width: 100%;
    white-space: nowrap;
    list-style: none;

    li {
      cursor: pointer;
    }
  }

  svg.icon {
    width: 3rem;
    height: 3rem;
  }

  .buttons {
    display: flex;
    gap: 1.5rem;
    align-items: center;

    button {
      display: flex;
      align-items: center;
    }
  }

  button.side-nav-button svg {
    transition: transform 0.2s ease-in-out;

    &:hover {
      transform: scale(1.08);
    }
  }

  @media ${device.laptopS} {
    ul.nav-links {
      display: none;
    }
  }

  @media ${device.mobileL} {
    .log-in {
      display: none;
    }

    nav {
      gap: 1.5rem;
    }
  }
`;

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [isSideNav, setIsSideNav] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
        setDropdownOpen({});
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleDropdown = (index) => {
    setDropdownOpen((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <>
      <ContactHeader />
      <StyledHeader className={scrolled ? "scrolled-header" : ""}>
        <nav className="width-wrapper">
          <h1>
            <Link to="/">
              <StaticImage
                src="../images/logo.png"
                alt="QTA Tax"
                className="logo"
                placeholder="none"
              />
            </Link>
          </h1>
          <ul className="nav-links">
            {headerLinks.map((link, index) => (
              <li
                key={link.title}
                onMouseEnter={() => link.dropdownLinks && toggleDropdown(index)}
                onMouseLeave={() => link.dropdownLinks && toggleDropdown(index)}
                className={`poppins-500 ${scrolled ? "body-sm" : "body-md"}`}
              >
                <Link to={link.href ? link.href : "/"}>
                  {link.title}{" "}
                  {link.dropdownLinks
                    ? dropdownOpen[index]
                      ? " –"
                      : " +"
                    : ""}
                </Link>
                {link.dropdownLinks && (
                  <DropdownNav
                    isOpen={dropdownOpen[index]}
                    links={link.dropdownLinks}
                    scrolled={scrolled}
                  />
                )}
              </li>
            ))}
          </ul>
          <div className="buttons">
            <button
              onClick={() => setIsSideNav(true)}
              className="side-nav-button"
            >
              <HiMenu className="icon" />
            </button>
            <Button
              text="Client log in"
              href="https://qtatax.taxdome.com/login"
              className="log-in"
              round
            />
          </div>
        </nav>
      </StyledHeader>
      <SideNav
        isSideNav={isSideNav}
        setIsSideNav={setIsSideNav}
        setIsDropdownNav={setDropdownOpen}
        isDropdownNav={dropdownOpen}
      />
    </>
  );
};

export default Header;
